import TabViewModel from "../../../../Lib/Fs.SmartClient.Client/TabViewModel";
import FsUtility from "../../../../Lib/Fs.SmartClient.Client/FsUtility";
import { useView, autoinject, Container } from 'aurelia-framework'
import { OpenIdConnect, OpenIdConnectRoles } from "aurelia-open-id-connect";
import ChangePasswordAppService from "../../Scripts/AppServiceContract/ChangePasswordAppService";
import { PLATFORM } from 'aurelia-pal';

@autoinject
@useView(PLATFORM.moduleName("./ForgetPasswordView.html"))
export default class ForgetPasswordVM extends TabViewModel {

    public Email: string;

    public OpenIdConnect: OpenIdConnect;

    constructor(openIdConnect: OpenIdConnect) {
        super();
        this.OpenIdConnect = openIdConnect;
    }

    public Cancel() {
        window.history.back();
    }

    public Submit() {
        var self = this;
        var service = this.container.get(ChangePasswordAppService) as ChangePasswordAppService;
        service.SendForgetPasswordEmail(this.Email).done(function (result) {
            FsUtility.AlertModal("Send reset password successful", 2, 1, function (result) {
                window.history.back();
            });
        }).fail((error) => {
            FsUtility.AlertErrorMessage(error);
        });
    }
}
